import ShareModalDrawerTextMessage from './ShareModalDrawerTextMessage';

export default ShareModalDrawerTextMessage;
